export const mockedFolders = [
  { label: 'HR forms', value: 1 },
  { label: 'Vehicle collection', value: 2 },
  { label: 'Temp folder', value: 3 },
  { label: 'Spec templates', value: 4 },
];
